module.exports = __webpack_public_path__ + "static/bluemuslinorganicmain-e751eaa079f7b50bc7596a4dd3fc2311.png";